// Prevents selecting the same color value in two "matching" swatch pickers
// on the same product (e.g. an "Outer Color" and "Inner Color" pair that
// share the same palette). Works for any current or future product with
// this pattern, without hardcoding option names.
(function () {
  // Products where picking the same color in both pickers is allowed on
  // purpose (e.g. a solid single-color version), so the restriction below
  // is skipped for them.
  var EXEMPT_HANDLES = ['triangle-passthrough', 'mini-triangle-passthrough'];

  function productHandleFromUrl(url) {
    var match = /\/products\/([^/?]+)/.exec(url || '');
    return match ? match[1] : null;
  }

  function isExemptPicker(picker) {
    var handle =
      productHandleFromUrl(picker.dataset && picker.dataset.productUrl) ||
      productHandleFromUrl(window.location.pathname);
    return EXEMPT_HANDLES.indexOf(handle) !== -1;
  }

  function fieldsetSignature(fieldset) {
    return Array.from(fieldset.querySelectorAll('input[type="radio"]'))
      .map(function (input) {
        return input.value.trim().toLowerCase();
      })
      .sort()
      .join('|');
  }

  function optionName(fieldset) {
    var legend = fieldset.querySelector('legend');
    if (!legend) return 'the other option';
    return legend.textContent.trim().replace(/\s+/g, ' ');
  }

  function showWarning(fieldset, message) {
    var warning = fieldset.querySelector('.duplicate-color-warning');
    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'duplicate-color-warning';
      warning.setAttribute('role', 'alert');
      warning.style.cssText =
        'color:#c0392b;font-size:0.85em;margin-top:0.5em;width:100%;';
      fieldset.appendChild(warning);
    }
    warning.textContent = message;
    clearTimeout(warning._hideTimer);
    warning._hideTimer = setTimeout(function () {
      warning.remove();
    }, 4000);
  }

  // Groups fieldsets on a picker by shared palette signature (2+ fieldsets
  // offering the identical set of colors count as a "matching colors" group).
  function findGroups(picker) {
    var fieldsets = Array.from(picker.querySelectorAll('fieldset.variant-option'));
    var groups = {};
    fieldsets.forEach(function (fs) {
      var sig = fieldsetSignature(fs);
      if (!sig) return;
      (groups[sig] = groups[sig] || []).push(fs);
    });
    return Object.keys(groups)
      .map(function (sig) {
        return groups[sig];
      })
      .filter(function (group) {
        return group.length > 1;
      });
  }

  // Fixes a product's *default/current* selection if it already has the same
  // color picked in two matching fieldsets (e.g. a product whose default
  // variant is Cyan outer + Cyan inner). This covers the case where a
  // customer never touches the swatches and goes straight to "Add to cart".
  function fixExistingDuplicates(picker) {
    if (isExemptPicker(picker)) return;
    findGroups(picker).forEach(function (group) {
      var usedValues = [];
      group.forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        if (!checked) {
          usedValues.push(null);
          return;
        }
        var value = checked.value.trim().toLowerCase();
        if (usedValues.indexOf(value) === -1) {
          usedValues.push(value);
          return;
        }

        // This fieldset duplicates a color already used earlier in the group.
        // Reassign it to the first available color not already in use.
        var alternative = Array.from(fieldset.querySelectorAll('input')).find(function (input) {
          return usedValues.indexOf(input.value.trim().toLowerCase()) === -1;
        });

        if (!alternative) return; // No alternative color available; leave as-is.

        var originalValue = checked.value;
        alternative.checked = true;
        usedValues.push(alternative.value.trim().toLowerCase());

        showWarning(
          fieldset,
          'Changed from "' + originalValue + '" to "' + alternative.value + '" so it isn\'t the same color twice.'
        );

        // Let the theme's own variant-picker handler process this like any
        // other selection, so price/URL/variant stay in sync.
        alternative.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  document.querySelectorAll('variant-picker').forEach(fixExistingDuplicates);

  // Product pages can swap in a new variant-picker (combined listings,
  // quick-add modals, etc.) after initial load - catch those too.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches('variant-picker')) fixExistingDuplicates(node);
        if (node.querySelectorAll) {
          Array.from(node.querySelectorAll('variant-picker')).forEach(fixExistingDuplicates);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

      var fieldset = target.closest('fieldset.variant-option');
      var picker = target.closest('variant-picker');
      if (!fieldset || !picker) return;
      if (isExemptPicker(picker)) return;

      var mySig = fieldsetSignature(fieldset);
      if (!mySig) return;

      var siblingFieldsets = Array.from(
        picker.querySelectorAll('fieldset.variant-option')
      ).filter(function (fs) {
        return fs !== fieldset && fieldsetSignature(fs) === mySig;
      });

      // Only restrict when this option shares its full palette with another
      // option on the same product (i.e. it's a "matching colors" pair).
      if (siblingFieldsets.length === 0) return;

      var newValue = target.value.trim().toLowerCase();

      var conflictingFieldset = siblingFieldsets.find(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked && checked.value.trim().toLowerCase() === newValue;
      });

      if (!conflictingFieldset) return;

      // Stop this change from ever reaching the theme's variant-picker
      // handler, so no fetch/URL/price update happens for the invalid pick.
      event.stopImmediatePropagation();

      var previousValid = fieldset.querySelector('input[data-current-checked="true"]');
      target.checked = false;
      if (previousValid) previousValid.checked = true;

      showWarning(
        fieldset,
        '"' +
          target.value +
          '" is already picked for ' +
          optionName(conflictingFieldset) +
          '. Please choose a different color.'
      );
    },
    true
  );
})();
